import Vuex from 'vuex';
import api from '@/api';

export let store;

export const init = function() {
  store = new Vuex.Store({
    state: {
      stations: null,
      stationsLoading: false,
      stationsError: false,

      uom: null, // { units: [], groups: [], subtypes: [] }
      uomLoading: false,
      uomError: false,
    },
    mutations: {
      setStations(state, stations) {
        state.stations = stations;
      },
      setStationsLoading(state, value) {
        state.stationsLoading = value;
      },
      setStationsError(state, value) {
        state.stationsError = value;
      },
      setUOM(state, uom) {
        state.uom = uom;
      },
      setUOMLoading(state, value) {
        state.uomLoading = value;
      },
      setUOMError(state, value) {
        state.uomError = value;
      },
    },
    // getters: {},
    actions: {
      async refreshStations(vuexContext, { vendor, organizationId, resourceId }) {
        vuexContext.commit('setStationsLoading', true);
        vuexContext.commit('setStationsError', false);
  
        const stations = [];
        let done = false;
        let skip = 0;
        let batchSize = 16;
        let failCount = 0;
  
        while (!done) {
          try {
            const batch = await api.getUserStationBatch({
              vendor,
              organizationId,
              resourceId,
              skip,
              limit: batchSize,
              brief: false,
            });

            stations.push(...batch.data);
            skip += batchSize;

            if (batch.data.length < batchSize) {
              done = true;
            }
          } catch (err) {
            failCount++;
            if (failCount < 3) {
              batchSize = batchSize / 2;
            } else {
              done = true;
            }
          }
        }

        if (failCount === 3) {
          vuexContext.commit('setStationsError', true);
        } else {
          vuexContext.commit('setStations', stations);
        }

        vuexContext.commit('setStationsLoading', false);
      },
      async refreshUOM(vuexContext) {
        vuexContext.commit('setUOMLoading', true);
        vuexContext.commit('setUOMError', false);
  
        // 1 retry for each call
        const unitPromise = api.getUOMUnits().catch(async (err) => {
          await new Promise(res => { setTimeout(res, 3000) });
          return api.getUOMUnits();
        });
        const groupPromise = api.getUOMGroups().catch(async (err) => {
          await new Promise(res => { setTimeout(res, 3000) });
          return api.getUOMGroups();
        });
        const subtypePromise = api.getUOMSubtypes().catch(async (err) => {
          await new Promise(res => { setTimeout(res, 3000) });
          return api.getUOMSubtypes();
        });

        try {
          const [ units, groups, subtypes ] = await Promise.all([
            unitPromise,
            groupPromise,
            subtypePromise,
          ]);

          vuexContext.commit('setUOM', {
            units: units.data,
            groups: groups.data,
            subtypes: subtypes.data,
          });
        } catch (err) {
          vuexContext.commit('setUOMError', true);
        } finally {
          vuexContext.commit('setUOMLoading', false);
        }
      },
    },
  });
};

export default store;